/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownloadFromJSON, FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownloadToJSON, } from './FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownload';
import { FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultTorrentFromJSON, FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultTorrentToJSON, } from './FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultTorrent';
/**
 * Check if a given object implements the FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultLauncherConfiguration interface.
 */
export function instanceOfFtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultLauncherConfiguration(value) {
    if (!('CreatedAt' in value) || value['CreatedAt'] === undefined)
        return false;
    if (!('UpdatedAt' in value) || value['UpdatedAt'] === undefined)
        return false;
    if (!('Name' in value) || value['Name'] === undefined)
        return false;
    if (!('StartMenuName' in value) || value['StartMenuName'] === undefined)
        return false;
    if (!('LaunchFile' in value) || value['LaunchFile'] === undefined)
        return false;
    if (!('InstallerFile' in value) || value['InstallerFile'] === undefined)
        return false;
    if (!('LaunchParams' in value) || value['LaunchParams'] === undefined)
        return false;
    if (!('ConfigurationBucket' in value) || value['ConfigurationBucket'] === undefined)
        return false;
    if (!('Torrent' in value) || value['Torrent'] === undefined)
        return false;
    if (!('HttpDownload' in value) || value['HttpDownload'] === undefined)
        return false;
    if (!('ManifestUrl' in value) || value['ManifestUrl'] === undefined)
        return false;
    if (!('ManifestSha256' in value) || value['ManifestSha256'] === undefined)
        return false;
    return true;
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultLauncherConfigurationFromJSON(json) {
    return FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultLauncherConfigurationFromJSONTyped(json, false);
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultLauncherConfigurationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'CreatedAt': (new Date(json['createdAt'])),
        'UpdatedAt': (new Date(json['updatedAt'])),
        'Name': json['name'],
        'StartMenuName': json['startMenuName'],
        'LaunchFile': json['launchFile'],
        'InstallerFile': json['installerFile'],
        'LaunchParams': json['launchParams'],
        'ConfigurationBucket': json['configurationBucket'],
        'Torrent': FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultTorrentFromJSON(json['torrent']),
        'HttpDownload': FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownloadFromJSON(json['httpDownload']),
        'ManifestUrl': json['manifestUrl'],
        'ManifestSha256': json['manifestSha256'],
    };
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultLauncherConfigurationToJSON(json) {
    return FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultLauncherConfigurationToJSONTyped(json, false);
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultLauncherConfigurationToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'createdAt': ((value['CreatedAt']).toISOString()),
        'updatedAt': ((value['UpdatedAt']).toISOString()),
        'name': value['Name'],
        'startMenuName': value['StartMenuName'],
        'launchFile': value['LaunchFile'],
        'installerFile': value['InstallerFile'],
        'launchParams': value['LaunchParams'],
        'configurationBucket': value['ConfigurationBucket'],
        'torrent': FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultTorrentToJSON(value['Torrent']),
        'httpDownload': FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownloadToJSON(value['HttpDownload']),
        'manifestUrl': value['ManifestUrl'],
        'manifestSha256': value['ManifestSha256'],
    };
}
//# sourceMappingURL=FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultLauncherConfiguration.js.map